import * as RadixDialog from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';

import { cx } from './cx';

type DialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: ReactNode;
  width?: number;
};

export function Dialog({ open, onOpenChange, title, description, children, width = 520 }: DialogProps) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay
          style={{
            position: 'fixed',
            inset: 0,
            background: 'oklch(0.18 0.01 85 / 0.4)',
            backdropFilter: 'blur(2px)',
            zIndex: 50,
          }}
        />
        <RadixDialog.Content
          className={cx('mf-card')}
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width,
            maxWidth: 'calc(100vw - 32px)',
            maxHeight: '90vh',
            overflowY: 'auto',
            zIndex: 51,
            boxShadow: 'var(--sh-lg)',
            padding: 24,
          }}
        >
          {title && (
            <RadixDialog.Title
              className="display"
              style={{ fontSize: 20, fontWeight: 500, margin: '0 0 6px' }}
            >
              {title}
            </RadixDialog.Title>
          )}
          {description && (
            <RadixDialog.Description style={{ fontSize: 13, color: 'var(--ink-2)', margin: '0 0 16px' }}>
              {description}
            </RadixDialog.Description>
          )}
          {children}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}

Dialog.Trigger = RadixDialog.Trigger;
Dialog.Close = RadixDialog.Close;
